function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

import { h, Component } from 'preact';

var _handleKeyPress = /*#__PURE__*/_classPrivateFieldLooseKey("handleKeyPress");

var _handleSubmit = /*#__PURE__*/_classPrivateFieldLooseKey("handleSubmit");

var UrlUI = /*#__PURE__*/function (_Component) {
  _inherits(UrlUI, _Component);

  var _super = _createSuper(UrlUI);

  function UrlUI() {
    var _this;

    _classCallCheck(this, UrlUI);

    _this = _super.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this), _handleKeyPress, {
      writable: true,
      value: function value(ev) {
        if (ev.keyCode === 13) {
          _classPrivateFieldLooseBase(_assertThisInitialized(_this), _handleSubmit)[_handleSubmit]();
        }
      }
    });
    Object.defineProperty(_assertThisInitialized(_this), _handleSubmit, {
      writable: true,
      value: function value() {
        var addFile = _this.props.addFile;

        var preparedValue = _this.input.value.trim();

        addFile(preparedValue);
      }
    });
    return _this;
  }

  _createClass(UrlUI, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.input.value = '';
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var i18n = this.props.i18n;
      return h("div", {
        className: "uppy-Url"
      }, h("input", {
        className: "uppy-u-reset uppy-c-textInput uppy-Url-input",
        type: "text",
        "aria-label": i18n('enterUrlToImport'),
        placeholder: i18n('enterUrlToImport'),
        onKeyUp: _classPrivateFieldLooseBase(this, _handleKeyPress)[_handleKeyPress],
        ref: function ref(input) {
          _this2.input = input;
        },
        "data-uppy-super-focusable": true
      }), h("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Url-importButton",
        type: "button",
        onClick: _classPrivateFieldLooseBase(this, _handleSubmit)[_handleSubmit]
      }, i18n('import')));
    }
  }]);

  return UrlUI;
}(Component);

export default UrlUI;